import React, { useState, useEffect, useRef, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import getCookie from "../../api";
import "../../css_files/Ticket/Step2Ticket.css";
import { ToWords } from "to-words";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import { triggerscroll } from "../Homepage/Homepage";

function Step2Ticket({ setCatchStep, enquiryId, ticketId, setQuotationId }) {
  setCatchStep(useLocation().pathname.split("/")[4].trim());

  const [newEnquiryData, setNewEnquiryData] = useState();
  const [actualTicketId, setActualTicketId] = useState(0);
  const [CurrencyData, setCurrencyData] = useState([]);
  const { userData, permissionsdata } = useContext(triggerscroll);
  const [quotationData, setQuotationData] = useState({
    finalTotal: 0.0,
    grandtotal: 0.0,
    gstAmount: 0.0,
    selectedgstPercentage: 18,
    discountAmount: 0.0,
    discountPercentage: 0,
    packingForwarding: 0.0,
    courierExp: 0.0,
  });
  const nav = useNavigate();
  const [declaration, setdeclaration] = useState("");
  const [partdataloading, setpartdataloading] = useState(false);
  const [currencyAbbr, setCurrencyAbbr] = useState("INR");
  const [loading, setloading] = useState(false);
  const toWords = new ToWords({
    localeCode: "en-IN",
  });

  const [QuotationItemsData, setQuotationItemsData] = useState(
    Array.from({ length: 8 }, (_, i) => ({
      SrNo: i + 1,
      Description: "",
      PricePerDay: "",
      NoOfDays: "",
      Total: "",
    }))
  );

  const [PartsItemData, setPartsItemData] = useState([]);
  const [BackupPartsItemData, setBackupPartsItemData] = useState([]);

  const [ProcedureData, setProcedureData] = useState(
    Array.from({ length: 10 }, (_, i) => {
      return {
        SrNo: i + 1,
        Description: "",
      };
    })
  );

  const [CommercialTermsData, setCommercialTermsData] = useState(
    Array.from({ length: 10 }, (_, i) => ({
      SrNo: i + 1,
      Title: "",
      Description: "",
    }))
  );

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Ticket/${encodeURIComponent(
          ticketId
        )}`
      )
      .then((res) => {
        setActualTicketId(res.data.id);
      })
      .catch(console.log);
  }, [ticketId]);

  function getCurrencyData() {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Currency/GetCurrencyDropdown`
      )
      .then((res) => {
        setCurrencyData(res.data);
      })
      .catch(console.log);
  }

  function rateLogic(rate1, currency) {
    const rate = Math.round(rate1);
    let adjustby = 0;
    if (rate === 0) {
      return 0;
    }
    if (currency === "INR") {
      const last2Digits = rate % 100;

      if (last2Digits <= 50) {
        adjustby = 50 - last2Digits;
        const newRate = rate + adjustby;
        return newRate;
      } else {
        adjustby = 100 - last2Digits;
        const newRate = rate + adjustby;
        return newRate;
      }
    }
    return rate1;
  }

  useEffect(() => {
    if (newEnquiryData?.enquiryType === "Parts") {
      setpartdataloading(true);

      axiosInstance
        .get(
          `${
            process.env.REACT_APP_API_URL
          }/api/PartsTicket/${encodeURIComponent(ticketId)}`
        )
        .then((resp) => {
          setPartsItemData(
            resp.data.map((x) => {
              const rate =
                Number(x.part.sellingPrice || 0) +
                Number(x.part.sellingPrice || 0) *
                  (Number(newEnquiryData?.customer?.pricing?.percentage) / 100);

              return {
                PartNumber: x.part.partNumber,
                Name: x.part.name,
                HSNCode: x.part.hsn?.hsnCode,
                Quantity: "",
                Rate: rateLogic(rate, currencyAbbr),
                Amount: "",
              };
            })
          );

          setBackupPartsItemData(
            resp.data.map((x) => ({
              PartNumber: x.part.partNumber,
              Name: x.part.name,
              HSNCode: x.part.hsn?.hsnCode,
              Quantity: "",
              Rate:
                Number(x.part.sellingPrice || 0) +
                Number(x.part.sellingPrice || 0) *
                  (Number(newEnquiryData?.customer?.pricing?.percentage) / 100),
              Amount: "",
            }))
          );
        })
        .catch(console.log)
        .finally(() => {
          setpartdataloading(false);
        });
    }
  }, [newEnquiryData?.enquiryType, newEnquiryData?.customer?.code]);

  useEffect(() => {
    axiosInstance
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/api/v1/NewEnquiry/GetEnquiryById?seriesId=${encodeURIComponent(
          enquiryId
        )}`
      )
      .then((res) => {
        setNewEnquiryData(res.data);
      })
      .catch(console.log);
    getCurrencyData();
  }, []);

  function calculateTotal() {
    if (newEnquiryData?.enquiryType === "Parts") {
      return PartsItemData.reduce(
        (acc, curr) => acc + Number(curr.Amount),
        0.0
      ).toFixed(2);
    } else {
      return QuotationItemsData.reduce(
        (acc, curr) => acc + Number(curr.Total),
        0.0
      ).toFixed(2);
    }
  }

  useEffect(() => {
    const discountAmount = Number(
      Number(calculateTotal()) *
        (Number(quotationData.discountPercentage || "0") / 100)
    ).toFixed(2);
    const gstAmount = Number(
      (Number(calculateTotal()) +
        Number(quotationData.packingForwarding || "0") +
        Number(quotationData.courierExp || "0") -
        discountAmount) *
        (Number(quotationData.selectedgstPercentage) / 100)
    ).toFixed(2);

    const finalTotal = Number(
      Number(calculateTotal()) +
        Number(quotationData.packingForwarding || "0") +
        Number(quotationData.courierExp || "0") -
        Number(discountAmount)
    ).toFixed(2);

    const grandtotal = Number(Number(finalTotal) + Number(gstAmount)).toFixed(
      2
    );

    setQuotationData({
      ...quotationData,
      finalTotal,
      grandtotal,
      gstAmount,
      discountAmount,
    });
  }, [
    QuotationItemsData,
    PartsItemData,
    newEnquiryData?.enquiryType,
    quotationData.discountPercentage,
    quotationData.packingForwarding,
    quotationData.courierExp,
    quotationData.selectedgstPercentage,
  ]);

  async function handleSubmit() {
    if (calculateTotal() == "0.00") {
      Swal.fire({
        icon: "error",
        title: "Create Quotation Failed",
        text: "Quotation Amount Cannot be Zero",
      });
      return;
    }
    try {
      setloading(true);

      const res = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}/api/v1/Quotation`,
        {
          SubTotal: calculateTotal(),
          FinalTotal: quotationData.finalTotal,
          GSTAmount: quotationData.gstAmount,
          GrandTotal: quotationData.grandtotal,
          GSTPercentage: quotationData.selectedgstPercentage,
          TicketId: ticketId,
          EnquiryType: newEnquiryData.enquiryType,
          ActualTicketId: actualTicketId,
          Declaration: declaration,
          DiscountPercentage: quotationData.discountPercentage,
          DiscountValue: quotationData.discountAmount,
          Symbol: currencyAbbr,
          CompanyId: newEnquiryData.companyId,
          CourierExp: quotationData.courierExp,
          PackingForwarding: quotationData.packingForwarding,
        }
      );

      const quotationsByCustomerId = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/api/v1/Quotation/GetQuotationByCompanyId/${newEnquiryData.customer.id}`
      );
      await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}/api/v1/Customer/UpdateCustomerCommand`,
        {
          CustomerID: newEnquiryData.customer.id,
          Quotations: quotationsByCustomerId.data.length,
        }
      );

      const quotationId = res.data.id;
      setQuotationId(res.data.seriesId);
      let itemsToSend = [];
      if (newEnquiryData.enquiryType === "Parts") {
        itemsToSend = PartsItemData.filter((item) => item.Rate !== "").map(
          (item) =>
            axiosInstance.post(
              `${process.env.REACT_APP_API_URL}/api/PartItems`,
              {
                QuotationId: quotationId,
                PartNumber: item.PartNumber,
                PartName: item.Name,
                HSNCode: item.HSNCode || 0,
                Quantity: item.Quantity || 0,
                Rate: item.Rate || 0,
                Amount: item.Amount || 0,
              }
            )
        );
      } else {
        itemsToSend = QuotationItemsData.filter(
          (item) => item.PricePerDay !== ""
        ).map((item) =>
          axiosInstance.post(
            `${process.env.REACT_APP_API_URL}/api/QuotationItems/AddQuotationItems`,
            {
              QuotationId: quotationId,
              Description: item.Description,
              PricePerDay: item.PricePerDay,
              NoOfDays: item.NoOfDays || 0,
              Total: item.Total,
            }
          )
        );
      }

      const commercialTerms = CommercialTermsData.filter(
        (x) => x.Title !== ""
      ).map((x) =>
        axiosInstance.post(
          `${process.env.REACT_APP_API_URL}/api/CommercialTerms/AddCommercialTerms`,
          {
            QuotationId: quotationId,
            Title: x.Title,
            Description: x.Description,
          }
        )
      );

      if (newEnquiryData.enquiryType === "Service") {
        const procedures = ProcedureData.filter(
          (x) => x.Description !== ""
        ).map((x) =>
          axiosInstance.post(
            `${process.env.REACT_APP_API_URL}/api/ProcedureDetails/AddProcedure`,
            {
              QuotationId: quotationId,
              Description: x.Description,
            }
          )
        );
        await Promise.all([
          ...itemsToSend,
          ...procedures,
          ...commercialTerms,
          updateTicketStatus(),
        ]);
      } else {
        await Promise.all([
          ...itemsToSend,
          ...commercialTerms,
          updateTicketStatus(),
        ]);
      }
      setloading(false);
      Swal.fire({
        icon: "success",
        text: `Quotation Created Successfully with Id ${res.data.seriesId}`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Go To Quotations",
        cancelButtonText: "Go to Next Step",
        cancelButtonColor: "green",
        confirmButtonColor: "darkblue",
      }).then((x) => {
        if (x.isConfirmed) {
          nav("/dashboard/quotations");
        } else {
          nav("/dashboard/checkin/steps/step3");
        }
      });
    } catch (err) {
      setloading(false);

      toast.error(err?.response?.data ?? err?.message ?? "Failed", {
        position: "bottom-center",
        theme: "dark",
      });
    }
  }

  function serviceDescriptionValues(i) {
    switch (i) {
      case 0:
        setQuotationItemsData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1 ? { ...x, Description: "Service" } : x
          )
        );
        return;
      case 1:
        setQuotationItemsData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1 ? { ...x, Description: "To & Fro" } : x
          )
        );
        return;
      case 2:
        setQuotationItemsData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1 ? { ...x, Description: "Lodging" } : x
          )
        );
        return;
      case 3:
        setQuotationItemsData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1 ? { ...x, Description: "Boarding" } : x
          )
        );
        return;
    }
  }

  function procedureDescriptionValues(i) {
    switch (i) {
      case 0:
        setProcedureData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1
              ? {
                  ...x,
                  Description:
                    "Necessary service spares required during the visit will be provided by the customer. If any additional spares are supplied by us, they will be charged extra.",
                }
              : x
          )
        );
        return;
      case 1:
        setProcedureData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1
              ? {
                  ...x,
                  Description:
                    "We shall not be held responsible for any delay in service completion due to non-availability of required spares. Any additional days arising from such delays will be charged extra.",
                }
              : x
          )
        );
        return;
      case 2:
        setProcedureData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1
              ? {
                  ...x,
                  Description:
                    "The service activity and corresponding Service Report will be completed on the same day of the visit. The report must be signed by the Site In-Charge or the concerned official at the site.",
                }
              : x
          )
        );
        return;
      case 3:
        setProcedureData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1
              ? {
                  ...x,
                  Description:
                    "Any special tools, consumables, or additional manpower required to carry out the service work shall be arranged and provided by the customer.",
                }
              : x
          )
        );
        return;
      case 4:
        setProcedureData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1
              ? {
                  ...x,
                  Description:
                    "Our Service Technician will visit the site as per the mutually agreed schedule.",
                }
              : x
          )
        );
        return;
      case 5:
        setProcedureData((prev) =>
          prev.map((x) =>
            x.SrNo === i + 1
              ? {
                  ...x,
                  Description:
                    "In case the service work extends beyond the initially scheduled period, the additional days will be chargeable on a pro-rata basis.",
                }
              : x
          )
        );
        return;
    }
  }

  function commercialTermsValues(i) {
    if (newEnquiryData?.enquiryType === "Parts") {
      if (currencyAbbr == "INR") {
        switch (i) {
          case 0:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Prices",
                      Description: "Ex works",
                    }
                  : x
              )
            );
            return;
          case 1:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Packing & Forwarding",
                      Description: "Cardboard box",
                    }
                  : x
              )
            );
            return;
          case 2:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Insurance",
                      Description: "Extra, In buyers account",
                    }
                  : x
              )
            );
            return;
          case 3:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Taxes",
                      Description: "GST 18%",
                    }
                  : x
              )
            );
            return;
          case 4:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Transport",
                      Description: "Quoted extra",
                    }
                  : x
              )
            );
            return;
          case 5:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Payment",
                      Description: "100% advance by RTGS",
                    }
                  : x
              )
            );
            return;
          case 6:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Delivery",
                      Description: "3-4 weeks",
                    }
                  : x
              )
            );
            return;
          case 7:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Inspection",
                      Description: "At our works prior to dispatch.",
                    }
                  : x
              )
            );
            return;
          case 8:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Validity",
                      Description: "Quotation is valid for 30 days",
                    }
                  : x
              )
            );
            return;
          case 9:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Jurisdiction",
                      Description: "Subject to Pune jurisdiction.",
                    }
                  : x
              )
            );
            return;
        }
      } else {
        switch (i) {
          case 0:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Prices",
                      Description: "C & F Fiji Islands",
                    }
                  : x
              )
            );
            return;
          case 1:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Packing & Forwarding",
                      Description: "Wooden Crate",
                    }
                  : x
              )
            );
            return;
          case 2:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Insurance",
                      Description: "Extra, In buyers account",
                    }
                  : x
              )
            );
            return;
          case 3:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Taxes",
                      Description: "Nil for direct export",
                    }
                  : x
              )
            );
            return;
          case 4:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Transport",
                      Description: "Quoted extra",
                    }
                  : x
              )
            );
            return;
          case 5:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Payment",
                      Description:
                        "100% advance by T/T. All T/T charges to buyers account",
                    }
                  : x
              )
            );
            return;
          case 6:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Delivery",
                      Description: "8 - 10 Weeks",
                    }
                  : x
              )
            );
            return;
          case 7:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Inspection",
                      Description: "At our works prior to dispatch",
                    }
                  : x
              )
            );
            return;
          case 8:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Validity",
                      Description: "Quotation is valid for 30 days",
                    }
                  : x
              )
            );
            return;
          case 9:
            setCommercialTermsData((prev) =>
              prev.map((x) =>
                x.SrNo === i + 1
                  ? {
                      ...x,
                      Title: "Jurisdiction",
                      Description: "Subject to Pune jurisdiction",
                    }
                  : x
              )
            );
            return;
        }
      }
    } else {
      switch (i) {
        case 0:
          setCommercialTermsData((prev) =>
            prev.map((x) =>
              x.SrNo === i + 1
                ? {
                    ...x,
                    Title: "Payment",
                    Description: "100% Advance by RTGS",
                  }
                : x
            )
          );
          return;
        case 1:
          setCommercialTermsData((prev) =>
            prev.map((x) =>
              x.SrNo === i + 1
                ? {
                    ...x,
                    Title: "Commencement",
                    Description: "As per mutual understanding",
                  }
                : x
            )
          );
          return;
        case 2:
          setCommercialTermsData((prev) =>
            prev.map((x) =>
              x.SrNo === i + 1
                ? {
                    ...x,
                    Title: "Validity of Offer",
                    Description: "Quotation is Valid for 30 days",
                  }
                : x
            )
          );
          return;
        case 3:
          setCommercialTermsData((prev) =>
            prev.map((x) =>
              x.SrNo === i + 1
                ? {
                    ...x,
                    Title: "Jurisdiction",
                    Description: "Subject to Pune Jurisdiction",
                  }
                : x
            )
          );
          return;
      }
    }
  }

  useEffect(() => {
    QuotationItemsData.forEach((_, i) => serviceDescriptionValues(i));
    ProcedureData.forEach((_, i) => procedureDescriptionValues(i));
    CommercialTermsData.forEach((_, i) => commercialTermsValues(i));
    setdeclaration(
      newEnquiryData?.enquiryType === "Service"
        ? "Please confirm the work order along with the necessary payments so that we can schedule the visit of our service technician. We believe this proposal aligns with your requirements and look forward to your response. Thank you for choosing our services – we remain committed to delivering exceptional quality and support. If you have any questions or need further clarification, please don't hesitate to contact us."
        : ""
    );
  }, [newEnquiryData?.enquiryType, currencyAbbr]);

  function updateTicketStatus() {
    return axiosInstance
      .put(`${process.env.REACT_APP_API_URL}/api/v1/Ticket`, {
        SeriesId: ticketId,
        IsQuotationSent: true,
      })
      .then((res) => "")
      .catch((err) => "");
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" &&
        x.subHead === "Quotation" &&
        x.isWrite === true
    );
    return !issatisfied;
  }

  return (
    <section className="step2-ticket">
      {newEnquiryData && (
        <>
          <div>
            <aside>
              <blockquote>
                <h1>Add {newEnquiryData?.enquiryType}</h1>
              </blockquote>
              <blockquote>
                <p>
                  <strong>Date: </strong>
                  {new Date(newEnquiryData.dateOfEnquiry).toLocaleDateString()}
                </p>
                <button>
                  Total: {currencyAbbr} {quotationData.grandtotal}
                </button>
              </blockquote>
            </aside>
          </div>

          <blockquote>
            <p>
              <strong>Linked to Enquiry: </strong> {newEnquiryData.seriesID}
            </p>
            <p>
              <strong>Ticket Id: </strong> {ticketId}
            </p>
          </blockquote>
        </>
      )}
      {newEnquiryData?.enquiryType === "Service" ? (
        <div style={{ overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                <th>Sr.No.</th>
                <th>Description</th>
                <th>Price/Day</th>
                <th>Days</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {QuotationItemsData.map((quotationItem, i) => (
                <tr>
                  <td>{quotationItem.SrNo}</td>
                  <td>
                    <input
                      type="text"
                      placeholder="Enter Service Description"
                      onInput={(e) => {
                        e.target.value = e.target.value.slice(0, 200);
                      }}
                      onChange={(e) => {
                        setQuotationItemsData((prev) =>
                          prev.map((item) =>
                            item.SrNo === i + 1
                              ? { ...item, Description: e.target.value }
                              : item
                          )
                        );
                      }}
                      value={quotationItem.Description}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="Enter Price/Day"
                      onInput={(e) => {
                        e.target.value = e.target.value
                          .replace(/[^0-9.]/g, "")
                          .replace(/(\..*)\./g, "$1")
                          .replace(/^(\d*\.\d{2}).*$/, "$1");
                      }}
                      onChange={(e) => {
                        const value = e.target.value;

                        setQuotationItemsData((prev) =>
                          prev.map((item, idx) =>
                            idx === i
                              ? {
                                  ...item,
                                  PricePerDay: value,
                                  Total: Number(
                                    Number(value || 0) *
                                      Number(item.NoOfDays || 0)
                                  ).toFixed(2),
                                }
                              : item
                          )
                        );
                      }}
                      value={quotationItem.PricePerDay}
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      placeholder="Enter Number of Days"
                      onInput={(e) => {
                        e.target.value = e.target.value.slice(0, 5);
                      }}
                      onChange={(e) => {
                        const value = e.target.value;

                        setQuotationItemsData((prev) =>
                          prev.map((item, idx) =>
                            idx === i
                              ? {
                                  ...item,
                                  NoOfDays: value,
                                  Total: Number(
                                    (Number(item.PricePerDay) || 0) *
                                      (Number(value) || 0)
                                  ).toFixed(2),
                                }
                              : item
                          )
                        );
                      }}
                      value={quotationItem.NoOfDays}
                    />
                  </td>

                  <td>INR {quotationItem.Total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                <th>Sr.No.</th>
                <th>Part Number</th>
                <th>Part Name</th>
                <th>HSN Code</th>
                <th>Rate Per Part</th>
                <th>Quantity</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {PartsItemData.map((partItem, i) => (
                <tr>
                  <td>{i + 1}</td>
                  <td>{partItem.PartNumber}</td>
                  <td>{partItem.Name}</td>
                  <td>{partItem.HSNCode}</td>
                  <td>
                    <input
                      type="text"
                      onInput={(e) => {
                        e.target.value = e.target.value
                          .replace(/[^0-9.]/g, "")
                          .replace(/(\..*)\./g, "$1")
                          .replace(/^(\d*\.\d{2}).*$/, "$1");
                      }}
                      value={partItem.Rate}
                      onChange={(e) =>
                        setPartsItemData((prev) =>
                          prev.map((x, j) =>
                            j === i
                              ? {
                                  ...x,
                                  Rate: e.target.value,
                                  Amount: Number(
                                    Number(e.target.value || 0) *
                                      Number(x.Quantity || 0)
                                  ).toFixed(2),
                                }
                              : x
                          )
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      placeholder="Enter Quantity"
                      onChange={(e) => {
                        sessionStorage.setItem(i, e.target.value);
                        setPartsItemData((prev) =>
                          prev.map((x, j) =>
                            j === i
                              ? {
                                  ...x,
                                  Quantity: e.target.value,
                                  Amount: Number(
                                    Number(e.target.value || 0) *
                                      Number(x.Rate || 0)
                                  ).toFixed(2),
                                }
                              : x
                          )
                        );
                      }}
                      value={partItem.Quantity}
                    />
                  </td>
                  <td>
                    {currencyAbbr} {partItem.Amount}
                  </td>
                </tr>
              ))}
              {partdataloading && (
                <tr>
                  <td colSpan={7}>
                    <center style={{ padding: "2rem" }}>
                      <i className="fa-solid fa-circle-notch fa-2x fa-spin"></i>
                    </center>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <div>
        <div className="step2-ticket-extra-form">
          <aside>
            {newEnquiryData?.enquiryType === "Parts" && (
              <>
                <select
                  onChange={(e) => {
                    setPartsItemData(BackupPartsItemData);
                    const abbr = e.target.value.split(" ")[1];
                    if (abbr === "INR") {
                      setQuotationData({
                        ...quotationData,
                        selectedgstPercentage: 18,
                      });
                    } else {
                      setQuotationData({
                        ...quotationData,
                        selectedgstPercentage: 0,
                      });
                    }

                    setPartsItemData((prev) =>
                      prev.map((x) => {
                        const rate = (
                          Number(x.Rate || "0") /
                          Number(e.target.value.split(" ")[0])
                        ).toFixed(2);

                        return {
                          ...x,
                          Rate: rateLogic(rate, abbr),
                          Amount: Number(
                            rate * Number(x.Quantity || 0)
                          ).toFixed(2),
                        };
                      })
                    );
                    setCurrencyAbbr(abbr);
                  }}
                >
                  <option disabled>Select Currency</option>
                  {CurrencyData.map((x) => (
                    <option
                      value={`${x.rate} ${x.code}`}
                      selected={x.code === "INR"}
                    >{`${x.label} (${x.code})`}</option>
                  ))}
                </select>
                <input
                  type="text"
                  placeholder="Enter Packaging and Forwarding Charges"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1")
                      .replace(/^(\d*\.\d{2}).*$/, "$1");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setQuotationData({
                        ...quotationData,
                        packingForwarding: e.target.value || 0.0,
                      });
                    }
                  }}
                />
                <input
                  type="text"
                  placeholder="Enter Transport/Courier Charges"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1")
                      .replace(/^(\d*\.\d{2}).*$/, "$1");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setQuotationData({
                        ...quotationData,
                        courierExp: e.target.value || 0.0,
                      });
                    }
                  }}
                />
              </>
            )}
            <input
              type="number"
              placeholder="Enter Discount in Percentage"
              onInput={(e) => (e.target.value = e.target.value.slice(0, 2))}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setQuotationData({
                    ...quotationData,
                    discountPercentage: e.target.value || 0,
                  });
                }
              }}
            />
          </aside>
          <dl>
            <dt>Subtotal</dt>
            <dd>
              {currencyAbbr} {calculateTotal()}
            </dd>

            {newEnquiryData?.enquiryType === "Parts" && (
              <>
                <dt>Packing & Forwarding</dt>
                <dd>
                  {currencyAbbr} {quotationData.packingForwarding}
                </dd>
                <dt>Transport/Courier Charges</dt>
                <dd>
                  {currencyAbbr} {quotationData.courierExp}
                </dd>
              </>
            )}
            <dt>Discount ({quotationData.discountPercentage}%)</dt>
            <dd>
              {currencyAbbr} {quotationData.discountAmount}
            </dd>
            <dt>Total</dt>
            <dd>
              {currencyAbbr} {quotationData.finalTotal}
            </dd>
            {quotationData.selectedgstPercentage != 0 && (
              <>
                <dt>GST: ({quotationData.selectedgstPercentage}%)</dt>
                <dd>
                  {currencyAbbr} {quotationData.gstAmount}
                </dd>
              </>
            )}
            <dt>Grand Total</dt>
            <dd>
              {currencyAbbr} {quotationData.grandtotal}
            </dd>
          </dl>
        </div>
        <aside>
          <p>
            <strong>Amount in Words: </strong>
            {toWords.convert(Math.round(quotationData.grandtotal || 0))}{" "}
            {currencyAbbr === "INR" ? "Only" : currencyAbbr}
          </p>
        </aside>
      </div>

      {newEnquiryData?.enquiryType === "Service" && (
        <div style={{ overflowX: "auto" }}>
          <h2>Procedures</h2>
          <table>
            <thead>
              <tr>
                <th>Sr.No.</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {ProcedureData.map((procedure, idx) => (
                <tr>
                  <td style={{ width: "2rem" }}>{procedure.SrNo}</td>
                  <td>
                    <input
                      type="text"
                      placeholder="Enter Procedure"
                      value={ProcedureData[idx].Description}
                      onChange={(e) => {
                        setProcedureData((prev) =>
                          prev.map((x) =>
                            x.SrNo == idx + 1
                              ? { ...x, Description: e.target.value }
                              : x
                          )
                        );
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div style={{ overflowX: "auto" }}>
        <h2>Commercial Terms</h2>
        <table>
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Title</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {CommercialTermsData.map((commercialterm, index) => (
              <tr>
                <td>{commercialterm.SrNo}</td>
                <td>
                  <input
                    type="text"
                    placeholder="Enter Title"
                    value={CommercialTermsData[index].Title}
                    onChange={(e) =>
                      setCommercialTermsData((prev) =>
                        prev.map((x) =>
                          x.SrNo === index + 1
                            ? { ...x, Title: e.target.value }
                            : x
                        )
                      )
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Enter Description"
                    value={CommercialTermsData[index].Description}
                    onChange={(e) =>
                      setCommercialTermsData((prev) =>
                        prev.map((x) =>
                          x.SrNo === index + 1
                            ? { ...x, Description: e.target.value }
                            : x
                        )
                      )
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div>
        {newEnquiryData?.enquiryType === "Service" && (
          <textarea
            value={declaration}
            onChange={(e) => setdeclaration(e.target.value)}
            rows={5}
          ></textarea>
        )}

        <button
          onClick={handleSubmit}
          id="GenerateQuotationButton"
          style={{
            pointerEvents: writePermission() && "none",
            opacity: writePermission() && 0.5,
          }}
        >
          {loading ? (
            <i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>
          ) : (
            <p>
              {writePermission()
                ? "You Do Not Have Permission To Create Quotation"
                : "Generate Quotation and Continue"}
            </p>
          )}
        </button>
      </div>
    </section>
  );
}

export default Step2Ticket;
